<template>
  <div class="report-wrapper">
    <SLAReportFilters @filterChange="onFilterChange" />
    <woot-button
      color-scheme="success"
      class-names="button--fixed-top"
      icon="arrow-download"
      @click="downloadReports"
    >
      {{ $t('SLA_REPORTS.DOWNLOAD_SLA_REPORTS') }}
    </woot-button>
    <div class="dashboard">
      <SLAMetrics
        :hit-rate="slaMetrics.hitRate"
        :no-of-breaches="slaMetrics.numberOfSLAMisses"
        :no-of-conversations="slaMetrics.numberOfConversations"
        :is-loading="uiFlags.isFetchingMetrics"
      />
    </div>
    <div class="row table-view">
      <div class="columns ">
        <no-result-card
          v-if="currentState === 'noResult'"
          :title="$t('CANNED_MGMT.NOT_FOUND.TITLE')"
        />
        <spinner-hoory v-if="currentState === 'loading'" class="margin-top-2" />
        <template v-if="currentState === 'records'">
          <SLATable
            :items="records"
            @goToConversation="execGoToConversation"
            @showDetails="execShowDetails"
          />
          <table-footer
            :current-page="Number(meta.currentPage)"
            :total-count="meta.count"
            :page-size="perPageCount"
            :records-count="records.length"
            @page-change="execPageChange"
          />
        </template>
      </div>
    </div>
    <SLA-popover-card
      v-if="showSlaPopoverCard"
      :style="{ bottom: bottom + 'px', right: right + 'px' }"
      :sla-missed-events="slaEvents"
      :sla-name="currentSlaName"
      :show-all="true"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SLAMetrics from './components/SLA/SLAMetrics.vue';
import SLATable from './components/SLA/SLATable.vue';
import SLAReportFilters from './components/SLA/SLAReportFilters.vue';
import { generateFileName } from 'dashboard/helper/downloadHelper';
import metaMixin from 'shared/mixins/metaMixin';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import NoResultCard from 'dashboard/components/ui/NoResultCard.vue';
import SpinnerHoory from 'shared/components/SpinnerHoory.vue';
import SLAPopoverCard from 'dashboard/components/widgets/conversation/components/SLAPopoverCard.vue';

export default {
  name: 'SLAReports',
  components: {
    SLAMetrics,
    SLATable,
    SLAReportFilters,
    TableFooter,
    NoResultCard,
    SLAPopoverCard,
    SpinnerHoory,
  },
  mixins: [metaMixin],
  data() {
    return {
      pageNumber: 1,
      activeFilter: {
        from: 0,
        to: 0,
        inbox_id: null,
      },
      perPageCount: 20,
      showSlaPopoverCard: false,
      currentSlaName: '',
      slaEvents: [],
      bottom: 0,
      right: 0,
    };
  },
  computed: {
    ...mapGetters({
      slaReports: 'slaReports/getAll',
      records: 'slaReports/getAll',
      slaMetrics: 'slaReports/getMetrics',
      meta: 'slaReports/getMeta',
      uiFlags: 'slaReports/getUIFlags',
      accountId: 'getCurrentAccountId',
    }),
  },
  mounted() {
    this.fetchSLAMetrics();
    this.fetchSLAReports();
  },
  methods: {
    updatePosition(event) {
      this.bottom = window.innerHeight - event.clientY;
      this.right = window.innerWidth - event.clientX;
    },
    execGoToConversation(data) {
      const url = `/app/accounts/${this.accountId}/conversations/${data.conversation.display_id}`;
      window.open(url, '_blank');
    },
    execShowDetails(data) {
      this.updatePosition(data.event);
      this.currentSlaName = data.row.applied_sla.sla_name;
      this.slaEvents = data.row.sla_events;
      this.showSlaPopoverCard = data.show;
    },
    fetchSLAReports(page = null) {
      this.$store.dispatch('slaReports/get', {
        page: page ?? this.meta.currentPage,
        ...this.activeFilter,
      });
    },
    fetchSLAMetrics() {
      this.$store.dispatch('slaReports/getMetrics', this.activeFilter);
    },
    onPageChange(pageNumber) {
      this.fetchSLAReports({ pageNumber });
    },
    onFilterChange(params) {
      this.activeFilter = params;
      this.fetchSLAReports(1);
      this.fetchSLAMetrics();
    },
    execPageChange(page) {
      this.fetchSLAReports(page);
      this.fetchSLAMetrics();
    },
    downloadReports() {
      const type = 'sla';
      try {
        this.$store.dispatch('slaReports/download', {
          fileName: generateFileName({ type, to: this.activeFilter.to }),
          ...this.activeFilter,
        });
      } catch (error) {
        // Ignore
      }
    },
  },
};
</script>

<style scoped>
.report-wrapper {
  display: flex; /* flex */
  flex-direction: column; /* flex-col */
  flex-grow: 1; /* flex-1 */
  gap: 1.5rem; /* gap-6 */
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem; /* px-4 */
  padding-top: 1rem; /* pt-4 */
  overflow: auto; /* overflow-auto */
}
.dashboard {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
</style>
